/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ConfirmationCode/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function ConfirmationCode({
  children,
  viewPath = "/App/Auth/SignUpConfirm/Content/ConfirmationCode",
  onChange,
  isInvalid,
  onSubmit
  
}) {
let signupConfirmCodeValueData = fromData.useDataValue({ viewPath,
context: 'signup_confirm',
path: 'code',
})
let signupConfirmCodeIsValidData = fromData.useDataIsValid({ viewPath,
context: 'signup_confirm',
path: 'code',
validate: fromValidate.signupCode,
required: true,
})
let signupConfirmCodeChangeData = fromData.useDataChange({ viewPath,
context: 'signup_confirm',
path: 'code',
})
let signupConfirmCodeSubmitData = fromData.useDataSubmit({ viewPath,
context: 'signup_confirm',
})
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={dtSpaceL}
 marginRight={0}
 data="signup_confirm.code"
 validate="/Data/validate.js signupCode"
 value={signupConfirmCodeValueData}
 onChange={signupConfirmCodeChangeData}
 invalid={!signupConfirmCodeIsValidData}
 onSubmit={signupConfirmCodeSubmitData}
 required={true}
 paddingBottom={dtSpaceS}
 paddingLeft={dtSpaceS}
 paddingRight={dtSpaceS}
 paddingTop={dtSpaceS}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 marginLeft={0}
 text="Verification code"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputFieldMasked
{...childProps}
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 autoFocus={true}
 mask="sixDigits"
 placeholder="000000&#8291;"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}